export default "__VITE_ASSET__77eb1c7f__"